import { Link } from 'react-router-dom';
import React from 'react';
import NavigationButtonCircle from 'Douleutaras/components/navigation-buttons/NavigationButtonCircle';

import './MobileNavigationHeader.scss';

export const MobileNavigationHeader = ({ goBackLink = '#' }: { goBackLink: string }) =>
<header>
  <div styleName="conversations-meta__header-left">
    <Link to={goBackLink}>
      <NavigationButtonCircle />
    </Link>
  </div>
</header>;

export default MobileNavigationHeader;
